import React, { useState } from "react";
import CallMadeIcon from "@mui/icons-material/CallMade";
import Skils from "./Skils";
import Experience from "./Experience";
import Tools from "./Tools";
import { Grid } from "@mui/material";
import "../assets/styles/skils.css";
const SkilsAndExperienceRoute = () => {
  const [component, setComponent] = useState(undefined);
  const [current, setCurrent] = useState(undefined);
  const tabs = [{ name: "Skils" }, { name: "Experience" }, { name: "Tools" }];

  const routes = [
    { name: "Skils", comp: <Skils current={current} /> },
    { name: "Experience", comp: <Experience current={current} /> },
    { name: "Tools", comp: <Tools current={current} /> },
  ];
  const hadleClick = (e) => {
    routes.map((page) => {
      if (page.name == e) {
        setCurrent(true);
        return setComponent(page.comp);
      }
    });
  };
  return (
    <div
      className="skils_expreinc_route_container"
      style={{ backgroundColor: "#0A192F", paddingBottom: "40px" }}
    >
      <Grid container>
        <Grid item xs={12} md={2}></Grid>
        <Grid item xs={12} md={8}>
          <div className="myExpert_details_container">
            {tabs.map((item, index) => {
              return (
                <button
                  onClick={() => hadleClick(item.name)}
                  key={index}
                  className={
                    index == 0 ? "tabs_index0" : "myExpert_details_Skils_btn"
                  }
                >
                  {item.name} <CallMadeIcon />
                </button>
              );
            })}
          </div>
          {component ? component : <Skils />}
        </Grid>
        <Grid item xs={12} md={2}></Grid>
      </Grid>
    </div>
  );
};

export default SkilsAndExperienceRoute;
